import { EventEmitter, Component, Input, Output, OnInit } from '@angular/core';
import { UserFavoriteCardData } from '../../../user-favorite-data.model';
import { LandingModelService } from '../../../../../services/landingModel.service';
import { isPlatformBrowser } from "@angular/common";
import { Inject, PLATFORM_ID } from "@angular/core";


declare var window: any;
@Component({
  selector: 'card-header',
  template: `
    <div class="header">
      <ng-content></ng-content>

      <div *ngIf="showDeleteBtn" (click)="handleStopPropagation($event)">
        <fav-heart
          [data]="{ external_id: externalId }"
          [options]="{ noBorder: false, white: true }"
          [product]="product.toLowerCase()"
          [locale]="locale"
          [clientType]="clientType"
          [xClient]="'nymeria'"
          [pageviewId]="pageviewId"
          [flow]="flow"
          (deleted)="handleClick()"
          [disableTooltip]="true"
          [favoriteFilled]="true"
        >
        </fav-heart>
      </div>
    </div>
  `,
  styles: [
    `
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .icon-wrapper {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 1px solid var(--brand-primary-3);
        cursor: pointer;
        color: var(--brand-primary-3);
        background-color: var(--color-white);
      }
    `,
  ],
})
export class CardHeaderComponent implements OnInit {
  @Input() externalId: UserFavoriteCardData['external_id'];
  @Input() showDeleteBtn: boolean;
  @Input() product: string;
  @Input() flow: string;
  clientType: 'WEB' | 'WEB_VIEW';
  locale: string;
  pageviewId: string;

  constructor(private landingModelService: LandingModelService, @Inject(PLATFORM_ID) public platformId: string) {}

  ngOnInit() {
    this.clientType = this.landingModelService.getLandingModel().webview
      ? 'WEB_VIEW'
      : 'WEB';
    this.locale = this.landingModelService.getLocale();

    if (isPlatformBrowser(this.platformId) && window) {
      this.pageviewId = window.upaData?.pageview_id;
    }
  }

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDeleteFavoriteClick = new EventEmitter();

  handleStopPropagation($event: Event) {
    $event.stopPropagation();
  }

  handleClick() {
    this.onDeleteFavoriteClick.emit();
  }
}
